var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpeechBubbleBlackSm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 34,
    viewBox: "0 0 70 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54.0415 7L50 0L45.9585 7H13.5C6.04416 7 0 13.0442 0 20.5C0 27.9558 6.04416 34 13.5 34H56.5C63.9558 34 70 27.9558 70 20.5C70 13.0442 63.9558 7 56.5 7H54.0415Z",
    fill: "#676ED3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeechBubbleBlackSm);
export default __webpack_public_path__ + "static/media/SpeechBubbleBlackSM.3e4e6555c8a31203beb2fd652d21e7ea.svg";
export { ForwardRef as ReactComponent };